import React from "react";

type Props = {
  className?: string;
  color?: string;
};

export const IconArrowRight: React.FC<Props> = ({
  className = "",
  color = "currentColor",
}) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 16.25L17.5 10L11.25 3.75M17.5 10H2.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
